import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { UPDATE_ATTRIBUTE_TYPE, UPDATE_PRODUCT } from '../types'; // Initial State

var reducer = function reducer(state, action) {
  switch (action.type) {
    case UPDATE_ATTRIBUTE_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          attributeType: action.payload
        });
      }

    case UPDATE_PRODUCT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedProduct: action.payload
        });
      }

    default:
      throw Error("Unknown action");
  }
};

export default reducer;